export const FALLBACK_MENU_DATA = {
  footerNav: [],
};

export const FILTERED_ITEMS_MAP_LOCAL_STORAGE_ID = "app-footer--filtered-items";
export const MENU_DATA_LOCAL_STORAGE_ID = "app-footer--menu-items";
export const INSIGHT_CURRENT_LOCALE_COOKIE_NAME = "insight_current_locale";
